import React, { ChangeEvent, Fragment, PureComponent } from 'react';
import { ButtonLink } from '../../components/Button';
import { Label, LabelSpan } from '../../components/Form';
import { Column, Row } from '../../components/Grid';
import { Paragraph } from '../../components/Paragraph';
import { Title } from '../../components/Title';
import { withErrorBoundary } from '../../error-handling/withErrorBoundary';
import {
  withNearestVehicleCenter,
  WithNearestVehicleCenterProps
} from '../../provider/NearestVehicleCenterProvider/withNearestVehicleCenter';
import {
  selectMenu,
  selectVehicleCenters
} from '../../provider/Typo3Provider/selectors';
import { MenuEntry, VehicleCenter } from '../../provider/Typo3Provider/types';
import Typo3Label from '../../provider/Typo3Provider/Typo3Label';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import { Maybe } from '../../types';
import Select from './components/Select';
import LocationOptions from './LocationOptions';

export interface StickyContactFormProps {
  closeModal?: () => void;
}

interface StickyContactFormState {
  selectedVehicleCenter: Maybe<VehicleCenter>;
}

class StickyContactForm extends PureComponent<
  StickyContactFormProps & WithNearestVehicleCenterProps & WithTypo3Props,
  StickyContactFormState
> {
  public state: StickyContactFormState = {
    selectedVehicleCenter:
      this.props.nearestVehicleCenter.vehicleCenter ||
      this.getVehicleCenters()[0]
  };

  public getVehicleCenters() {
    return selectVehicleCenters(this.props.typo3);
  }

  public getContactPage = (): Maybe<MenuEntry> => {
    const [contactpageEntry = null] = selectMenu(
      this.props.typo3,
      'contactpage'
    );
    return contactpageEntry;
  };

  public onSelectChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    const vehicleCenters = this.getVehicleCenters();

    const selectedVehicleCenter: Maybe<VehicleCenter> = vehicleCenters.find(
      ({ searchValue }) => searchValue === value
    );

    this.setState({
      selectedVehicleCenter
    });
  };

  public componentDidMount() {
    const { nearestVehicleCenter } = this.props;

    if (!nearestVehicleCenter) {
      return;
    }

    this.setState({
      selectedVehicleCenter: nearestVehicleCenter.vehicleCenter
    });
  }

  public render() {
    const { selectedVehicleCenter } = this.state;
    const { closeModal } = this.props;
    const contactpage = this.getContactPage();

    return (
      <Fragment>
        <Row>
          <Column>
            <Title.OverlayForm>
              <Typo3Label label="stickyContactForm.headline" />
            </Title.OverlayForm>
          </Column>
        </Row>
        <Row>
          <Column>
            <Paragraph>
              <Typo3Label label="stickyContactForm.body.expert">
                Möchten Sie mit unseren Bus-Experten in Neu-Ulm persönlich
                sprechen?
              </Typo3Label>
            </Paragraph>
            <Paragraph>
              <Typo3Label label="stickyContactForm.body.location">
                Oder wählen Sie einen alternativen Standort aus.
              </Typo3Label>
            </Paragraph>
          </Column>
        </Row>
        <Row>
          <Column>
            <Label>
              <LabelSpan>
                <Typo3Label label="stickyContactForm.label.location" />
              </LabelSpan>
              <Select
                value={
                  selectedVehicleCenter ? selectedVehicleCenter.searchValue : ''
                }
                onChange={this.onSelectChange}
                onBlur={this.onSelectChange}
                name="location"
              >
                <LocationOptions />
              </Select>
            </Label>

            {selectedVehicleCenter && (
              <ButtonLink
                to={{ pathname: selectedVehicleCenter.link, hash: '#contacts' }}
                primary
                large
                onClick={closeModal}
              >
                <Typo3Label label="stickyContactForm.button.contactPersons" />
              </ButtonLink>
            )}
          </Column>
        </Row>
        <Row>
          <Column>
            <Paragraph>
              <Typo3Label label="stickyContactForm.label.contact">
                Oder haben Sie eine allgemeine Frage, dann senden Sie uns gerne
                eine Nachricht über das Kontaktformular.
              </Typo3Label>
            </Paragraph>
            <ButtonLink
              to={{
                pathname: contactpage ? contactpage.link : '',
                state: {
                  codeLocation: selectedVehicleCenter
                    ? selectedVehicleCenter.searchValue
                    : ''
                }
              }}
              secondary
              large
              onClick={closeModal}
            >
              <Typo3Label label="stickyContactForm.button.contactForm" />
            </ButtonLink>
          </Column>
        </Row>
      </Fragment>
    );
  }
}

export default withErrorBoundary(
  withTypo3(withNearestVehicleCenter(StickyContactForm)),
  'StickyContactForm'
);
